import { postMessageWrapper } from "@/utils/iframeCommunication";
import { buildCovomoDisplayPreferencesStatePayload } from "@/utils/embedDisplaySettings";
import { getA11yDisplayPreferences } from "@/composables/useA11yDisplayPreferences";
import type { AppLocale } from "@/composables/appLocale";

let currentLocale: AppLocale = "de";
let debounceTimer: ReturnType<typeof setTimeout> | null = null;
const DEBOUNCE_MS = 48;

export function setDisplayPreferencesStateLocale(locale: AppLocale): void {
  currentLocale = locale;
}

/**
 * Sends `covomoDisplayPreferencesState` to `window.parent` (debounced; skips when not embedded).
 */
export function schedulePostDisplayPreferencesStateToParent(): void {
  if (typeof window === "undefined") return;
  if (debounceTimer !== null) clearTimeout(debounceTimer);
  debounceTimer = setTimeout(() => {
    debounceTimer = null;
    const payload = buildCovomoDisplayPreferencesStatePayload(
      currentLocale,
      getA11yDisplayPreferences(),
    );
    postMessageWrapper(payload, "*", true);
  }, DEBOUNCE_MS);
}
